export enum ProfileRoutingEnum {
  Root = ':profileId',
  Applications = 'applications',
  Bookmarks = 'bookmarks',
  View = '',
}
